<template>
    <div>
        <h5>Covid-19 Questionnaire</h5>

        <p v-if="isNew">
            Answer all the questions and click "Submit" to continue.
        </p>

        <template v-if="(isNew || submissionFound) && !isLoading">
            <form ref="covid19Form" @submit.prevent="validateForm">
                <table class="table-borderless">
                    <colgroup>
                        <col width="30">
                        <col>
                    </colgroup>
                    <tr>
                        <td style="vertical-align: top;">
                            <b>1.</b>
                        </td>
                        <td>
                            <div class="mb-2">
                                <b>
                                    Fever/ Demam (发烧)
                                </b>

                                <p v-if="validationErrors.has('question1')" class="text-danger">
                                    This question is required to be answered.
                                </p>
                            </div>

                            <div v-if="isNew">
                                <div class="custom-control custom-radio mb-3">
                                    <input name="question1" id="question1Yes" type="radio" class="custom-control-input" v-model="question1" value="Yes" v-validate="'required'">
                                    <label class="custom-control-label" for="question1Yes">
                                        Yes
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question1No" type="radio" class="custom-control-input" v-model="question1" value="No">
                                    <label class="custom-control-label" for="question1No">
                                        No
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question1Unsure" type="radio"  class="custom-control-input" v-model="question1" value="Unsure">
                                    <label class="custom-control-label" for="question1Unsure">
                                        Unsure
                                    </label>
                                </div>
                            </div>

                            <div class="mt-2 mb-2 text-primary" v-else>
                                {{ question1 }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td style="vertical-align: top;">
                            <b>
                                2.
                            </b>
                        </td>
                        <td>
                            <div class="mb-2">
                                <b>
                                    Headache/ Sakit kepala (头痛)
                                </b>

                                <p v-if="validationErrors.has('question2')" class="text-danger">
                                    This question is required to be answered.
                                </p>
                            </div>

                            <div v-if="isNew">
                                <div class="custom-control custom-radio mb-3">
                                    <input name="question2" id="question2Yes" type="radio" class="custom-control-input" v-model="question2" value="Yes" v-validate="'required'">
                                    <label class="custom-control-label" for="question2Yes">
                                        Yes
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question2No" type="radio" class="custom-control-input" v-model="question2" value="No">
                                    <label class="custom-control-label" for="question2No">
                                        No
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question2Unsure" type="radio" class="custom-control-input" v-model="question2" value="Unsure">
                                    <label class="custom-control-label" for="question2Unsure">
                                        Unsure
                                    </label>
                                </div>
                            </div>

                            <div class="mt-2 mb-2 text-primary" v-else>
                                {{ question2 }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td style="vertical-align: top;">
                            <b>
                                3.
                            </b>
                        </td>
                        <td>
                            <div class="mb-2">
                                <b>
                                    Fatigue/ Keletihan (疲劳/不适)
                                </b>

                                <p v-if="validationErrors.has('question3')" class="text-danger">
                                    This question is required to be answered.
                                </p>
                            </div>

                            <div v-if="isNew">
                                <div class="custom-control custom-radio mb-3">
                                    <input name="question3" id="question3Yes" type="radio" class="custom-control-input" v-model="question3" value="Yes" v-validate="'required'">
                                    <label class="custom-control-label" for="question3Yes">
                                        Yes
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question3No" type="radio" class="custom-control-input" v-model="question3" value="No">
                                    <label class="custom-control-label" for="question3No">
                                        No
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question3Unsure" type="radio" class="custom-control-input" v-model="question3" value="Unsure">
                                    <label class="custom-control-label" for="question3Unsure">
                                        Unsure
                                    </label>
                                </div>
                            </div>

                            <div class="mt-2 mb-2 text-primary" v-else>
                                {{ question3 }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td style="vertical-align: top;">
                            <b>
                                4.
                            </b>
                        </td>
                        <td>
                            <div class="mb-2">
                                <b>
                                    Shivering/ Menggigil (发冷)
                                </b>

                                <p v-if="validationErrors.has('question4')" class="text-danger">
                                    This question is required to be answered.
                                </p>
                            </div>

                            <div v-if="isNew">
                                <div class="custom-control custom-radio mb-3">
                                    <input name="question4" id="question4Yes" type="radio" class="custom-control-input" v-model="question4" value="Yes" v-validate="'required'">
                                    <label class="custom-control-label" for="question4Yes">
                                        Yes
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question4No" type="radio" class="custom-control-input" v-model="question4" value="No">
                                    <label class="custom-control-label" for="question4No">
                                        No
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question4Unsure" type="radio" class="custom-control-input" v-model="question4" value="Unsure">
                                    <label class="custom-control-label" for="question4Unsure">
                                        Unsure
                                    </label>
                                </div>
                            </div>

                            <div class="mt-2 mb-2 text-primary" v-else>
                                {{ question4 }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td style="vertical-align: top;">
                            <b>
                                5.
                            </b>
                        </td>
                        <td>
                            <div class="mb-2">
                            <b>
                                    Sore throat/Sakit Tekak (喉咙疼痛)
                            </b>

                                <p v-if="validationErrors.has('question5')" class="text-danger">
                                    This question is required to be answered.
                                </p>
                            </div>

                            <div v-if="isNew">
                                <div class="custom-control custom-radio mb-3">
                                    <input name="question5" id="question5Yes" type="radio" class="custom-control-input" v-model="question5" value="Yes" v-validate="'required'">
                                    <label class="custom-control-label" for="question5Yes">
                                        Yes
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question5No" type="radio" class="custom-control-input" v-model="question5" value="No">
                                    <label class="custom-control-label" for="question5No">
                                        No
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question5Unsure" type="radio" class="custom-control-input" v-model="question5" value="Unsure">
                                    <label class="custom-control-label" for="question5Unsure">
                                        Unsure
                                    </label>
                                </div>
                            </div>

                            <div class="mt-2 mb-2 text-primary" v-else>
                                {{ question5 }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td style="vertical-align: top;">
                            <b>
                                6.
                            </b>
                        </td>
                        <td>
                            <div class="mb-2">
                                <b>
                                    Running nose/ Hidung berair (流鼻涕)
                                </b>

                                <p v-if="validationErrors.has('question6')" class="text-danger">
                                    This question is required to be answered.
                                </p>
                            </div>

                            <div v-if="isNew">
                                <div class="custom-control custom-radio mb-3">
                                    <input name="question6" id="question6Yes" type="radio" class="custom-control-input" v-model="question6" value="Yes" v-validate="'required'">
                                    <label class="custom-control-label" for="question6Yes">
                                        Yes
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question6No" type="radio" class="custom-control-input" v-model="question6" value="No">
                                    <label class="custom-control-label" for="question6No">
                                        No
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question6Unsure" type="radio" class="custom-control-input" v-model="question6" value="Unsure">
                                    <label class="custom-control-label" for="question6Unsure">
                                        Unsure
                                    </label>
                                </div>
                            </div>

                            <div class="mt-2 mb-2 text-primary" v-else>
                                {{ question6 }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td rowspan="3" style="vertical-align: top;">
                            <b>
                                7.
                            </b>
                        </td>
                        <td>
                            <div>
                                <b>
                                    Cough/ Batuk (咳嗽)
                                </b>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="mb-2">
                                <b>
                                    No phlegm/ kering (干)
                                </b>

                                <p v-if="validationErrors.has('question7a')" class="text-danger">
                                    This question is required to be answered.
                                </p>
                            </div>

                            <div v-if="isNew">
                                <div class="custom-control custom-radio mb-3">
                                    <input name="question7a" id="question7aYes" type="radio" class="custom-control-input" v-model="question7a" value="Yes" v-validate="'required'">
                                    <label class="custom-control-label" for="question7aYes">
                                        Yes
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question7aNo" type="radio" class="custom-control-input" v-model="question7a" value="No">
                                    <label class="custom-control-label" for="question7aNo">
                                        No
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question7aUnsure" type="radio" class="custom-control-input" v-model="question7a" value="Unsure">
                                    <label class="custom-control-label" for="question7aUnsure">
                                        Unsure
                                    </label>
                                </div>
                            </div>

                            <div class="mt-2 mb-2 text-primary" v-else>
                                {{ question7a }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="mb-2">
                                <b>
                                    With phlegm/ berkahak (有痰)
                                </b>

                                <p v-if="validationErrors.has('question7b')" class="text-danger">
                                    This question is required to be answered.
                                </p>
                            </div>

                            <div v-if="isNew">
                                <div class="custom-control custom-radio mb-3">
                                    <input name="question7b" id="question7bYes" type="radio" class="custom-control-input" v-model="question7b" value="Yes" v-validate="'required'">
                                    <label class="custom-control-label" for="question7bYes">
                                        Yes
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question7bNo" type="radio" class="custom-control-input" v-model="question7b" value="No">
                                    <label class="custom-control-label" for="question7bNo">
                                        No
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question7bUnsure" type="radio" class="custom-control-input" v-model="question7b" value="Unsure">
                                    <label class="custom-control-label" for="question7bUnsure">
                                        Unsure
                                    </label>
                                </div>
                            </div>

                            <div class="mt-2 mb-2 text-primary" v-else>
                                {{ question7b }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td style="vertical-align: top;">
                            <b>
                                8.
                            </b>
                        </td>
                        <td>
                            <div class="mb-2">
                                <b>
                                    Shortness of breath/ sesak nafas (呼吸困难)
                                </b>

                                <p v-if="validationErrors.has('question8')" class="text-danger">
                                    This question is required to be answered.
                                </p>
                            </div>

                            <div v-if="isNew">
                                <div class="custom-control custom-radio mb-3">
                                    <input name="question8" id="question8Yes" type="radio" class="custom-control-input" v-model="question8" value="Yes" v-validate="'required'">
                                    <label class="custom-control-label" for="question8Yes">
                                        Yes
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question8No" type="radio" class="custom-control-input" v-model="question8" value="No">
                                    <label class="custom-control-label" for="question8No">
                                        No
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question8Unsure" type="radio" class="custom-control-input" v-model="question8" value="Unsure">
                                    <label class="custom-control-label" for="question8Unsure">
                                        Unsure
                                    </label>
                                </div>
                            </div>

                            <div class="mt-2 mb-2 text-primary" v-else>
                                {{ question8 }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td style="vertical-align: top;">
                            <b>
                                9.
                            </b>
                        </td>
                        <td>
                            <div class="mb-2">
                                <b>
                                    Conjunctivitis/ Konjunktivitis (结膜炎)
                                </b>

                                <p v-if="validationErrors.has('question9')" class="text-danger">
                                    This question is required to be answered.
                                </p>
                            </div>

                            <div v-if="isNew">
                                <div class="custom-control custom-radio mb-3">
                                    <input name="question9" id="question9Yes" type="radio" class="custom-control-input" v-model="question9" value="Yes" v-validate="'required'">
                                    <label class="custom-control-label" for="question9Yes">
                                        Yes
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question9No" type="radio" class="custom-control-input" v-model="question9" value="No">
                                    <label class="custom-control-label" for="question9No">
                                        No
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question9Unsure" type="radio" class="custom-control-input" v-model="question9" value="Unsure">
                                    <label class="custom-control-label" for="question9Unsure">
                                        Unsure
                                    </label>
                                </div>
                            </div>

                            <div class="mt-2 mb-2 text-primary" v-else>
                                {{ question9 }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td style="vertical-align: top;">
                            <b>
                                10.
                            </b>
                        </td>
                        <td>
                            <div class="mb-2">
                                <b>
                                    Joint or muscle pain/ Sakit sendi atau otot (关节或肌肉疼痛)
                                </b>

                                <p v-if="validationErrors.has('question10')" class="text-danger">
                                    This question is required to be answered.
                                </p>
                            </div>

                            <div v-if="isNew">
                                <div class="custom-control custom-radio mb-3">
                                    <input name="question10" id="question10Yes" type="radio" class="custom-control-input" v-model="question10" value="Yes" v-validate="'required'">
                                    <label class="custom-control-label" for="question10Yes">
                                        Yes
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question10No" type="radio" class="custom-control-input" v-model="question10" value="No">
                                    <label class="custom-control-label" for="question10No">
                                        No
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question10Unsure" type="radio" class="custom-control-input" v-model="question10" value="Unsure">
                                    <label class="custom-control-label" for="question10Unsure">
                                        Unsure
                                    </label>
                                </div>
                            </div>

                            <div class="mt-2 mb-2 text-primary" v-else>
                                {{ question10 }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td style="vertical-align: top;">
                            <b>
                                11.
                            </b>
                        </td>
                        <td>
                            <div class="mb-2">
                                <b>
                                    Joint or muscle pain/ Sakit sendi atau otot (关节或肌肉疼痛)
                                </b>

                                <p v-if="validationErrors.has('question11')" class="text-danger">
                                    This question is required to be answered.
                                </p>
                            </div>

                            <div v-if="isNew">
                                <div class="custom-control custom-radio mb-3">
                                    <input name="question11" id="question11Yes" type="radio" class="custom-control-input" v-model="question11" value="Yes" v-validate="'required'">
                                    <label class="custom-control-label" for="question11Yes">
                                        Yes
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question11No" type="radio" class="custom-control-input" v-model="question11" value="No">
                                    <label class="custom-control-label" for="question11No">
                                        No
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question11Unsure" type="radio" class="custom-control-input" v-model="question11" value="Unsure">
                                    <label class="custom-control-label" for="question11Unsure">
                                        Unsure
                                    </label>
                                </div>
                            </div>

                            <div class="mt-2 mb-2 text-primary" v-else>
                                {{ question11 }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td style="vertical-align: top;">
                            <b>
                                12.
                            </b>
                        </td>
                        <td>
                            <div class="mb-2">
                                <b>
                                    Vomiting or nausea/ Muntah atau mual (呕吐/恶心)
                                </b>

                                <p v-if="validationErrors.has('question12')" class="text-danger">
                                    This question is required to be answered.
                                </p>
                            </div>

                            <div v-if="isNew">
                                <div class="custom-control custom-radio mb-3">
                                    <input name="question12" id="question12Yes" type="radio" class="custom-control-input" v-model="question12" value="Yes" v-validate="'required'">
                                    <label class="custom-control-label" for="question12Yes">
                                        Yes
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question12No" type="radio" class="custom-control-input" v-model="question12" value="No">
                                    <label class="custom-control-label" for="question12No">
                                        No
                                    </label>
                                </div>
                                <div class="custom-control custom-radio mb-3">
                                    <input id="question12Unsure" type="radio" class="custom-control-input" v-model="question12" value="Unsure">
                                    <label class="custom-control-label" for="question12Unsure">
                                        Unsure
                                    </label>
                                </div>
                            </div>

                            <div class="mt-2 mb-2 text-primary" v-else>
                                {{ question12 }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td style="vertical-align: top;">
                            <b>
                                13.
                            </b>
                        </td>
                        <td>
                            <div class="mb-2">
                                <div>
                                    <b>
                                        Did you travel outside of the country/state/region in the past 14 days? If yes, please state the place, date and period of travel, mode of transport & accomodation etc..
                                    </b>
                                </div>
                                <div>
                                    <b>
                                        Adakah anda melancong di luar negara / negeri / rantau dalam 14 hari yang lalu? Jika ada, nyatakan tempat, tarikh dan tempoh perjalanan,cara pengangkutan & penginapan dan sebagainya
                                    </b>
                                </div>
                                <div>
                                    <b>
                                        在过去14天中，是否曾经到过国外/其他州属/地区？如果是，请说明旅行的地点，日期，交通工具和住宿方式等。
                                    </b>
                                </div>

                                <p v-if="validationErrors.has('question13')" class="text-danger">
                                    This question is required to be answered.
                                </p>
                            </div>

                            <div v-if="isNew" class="mb-3">
                                <textarea name="question13" class="form-control" rows="3" style="resize: none" v-model="question13" data-vv-validate-on="blur"  v-validate="'required'" :class="{
                                    'is-invalid': validationErrors.has('question13')
                                }">
                                </textarea>
                            </div>

                            <div class="mt-2 mb-2 text-primary" v-else>
                                {{ question13 }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td style="vertical-align: top;">
                            <b>
                                14.
                            </b>
                        </td>
                        <td>
                            <div class="mb-2">
                                <div>
                                    <b>
                                        History of close contact with COVID-19 positive patient/ quarantine patient/ PUI (Patient Under Investigation).
                                    </b>
                                </div>
                                <div>
                                    <b>
                                        Mempunyai KONTAK RAPAT dengan kes yang disahkan pesakit COVID-19 dalam tempoh 14 hari sebelum gejala anda bermula.
                                    </b>
                                </div>
                                <div>
                                    <b>
                                        是否曾经和新冠肺炎确诊病人/ 观察中或隔离中的人有密切接触。
                                    </b>
                                </div>

                                <p v-if="validationErrors.has('question14')" class="text-danger">
                                    This question is required to be answered.
                                </p>
                            </div>

                            <div v-if="isNew" class="mb-3">
                                <textarea name="question14" class="form-control" rows="3" style="resize: none" v-model="question14" data-vv-validate-on="blur" v-validate="'required'" :class="{
                                    'is-invalid': validationErrors.has('question14')
                                }">
                                </textarea>
                            </div>

                            <div class="mt-2 mb-2 text-primary" v-else>
                                {{ question14 }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <div v-if="isNew" class="mt-3">
                                <div class="custom-control custom-checkbox">
                                    <input name="confirmAcknowledgement" id="checkAcknowledge" type="checkbox" class="custom-control-input" v-validate="'required'">
                                    <label class="custom-control-label" for="checkAcknowledge">
                                        I, {{patientName}} of NRIC/Passport No.: {{ patientIcNumber }} acknowledge  that this declaration is true and correct, and I make it with the understanding and belief that a person who makes a false declaration is liable to the penalty of perjury.
                                    </label>
                                    <p v-if="validationErrors.has('confirmAcknowledgement')" class="text-danger">
                                        Please confirm your acknowledgement to continue.
                                    </p>
                                </div>

                            </div>
                        </td>
                    </tr>
                </table>
            </form>
            <p v-if="hasErrors" class="mt-3 mb-3 text-danger">
                There's errors in the questionnaire above. Please answer all the questions above before proceeding to the next step.
            </p>

            <div v-if="!isNew" class="mt-5">
                <p>
                    I, {{ patientName }} of NRIC/Passport No.: {{ patientIcNumber }} acknowledge  that this declaration is true and correct, and I make it with the understanding and belief that a person who makes a false declaration is liable to the penalty of perjury.
                </p>
                <p>Submission Date: {{ submissionDate }}</p>
            </div>
        </template>
        <template v-else>
            <p>
                {{ isLoading ? "Loading Covid-19 Questionnaire..." : "No Covid-19 questionnaire is submitted for this consultation." }}
            </p>
        </template>
    </div>
</template>

<script>
import {
    convertToUserReadableDateTime
} from '@/utilities';
export default {
    'name': 'QuestionnaireCovid19',
    'props': {
        'isNew': {
            'type': Boolean,
            'default': false
        },
        'patientName': {
            'type': String
        },
        'patientIcNumber': {
            'type': String
        },
        'consultationId': {
            'type': String | Number,
            'default': 0
        }
    },
    data () {
        return {
            'question1': '',
            'question2': '',
            'question3': '',
            'question4': '',
            'question5': '',
            'question6': '',
            'question7a': '',
            'question7b': '',
            'question8': '',
            'question9': '',
            'question10': '',
            'question11': '',
            'question12': '',
            'question13': '',
            'question14': '',
            'submissionDate': '',
            'submissionFound': true,
            'isLoading': false
        };
    },
    'computed': {
        hasErrors () {
            return this.validationErrors.items.length > 0;
        }
    },
    'watch': {
        consultationId (val) {
            if (val) {
                this.getSubmittedForm(val);
            } else {
                this.submissionFound = false;
            }
        }
    },
    mounted () {
        if (this.consultationId) {
            this.getSubmittedForm(this.consultationId);
        } else {
            this.submissionFound = false;
        }
    },
    'methods': {
        validateForm () {
            return this.$validator.validateAll();
        },
        getFormData () {
            return {
                'question1': this.question1,
                'question2': this.question2,
                'question3': this.question3,
                'question4': this.question4,
                'question5': this.question5,
                'question6': this.question6,
                'question7a': this.question7a,
                'question7b': this.question7b,
                'question8': this.question8,
                'question9': this.question9,
                'question10': this.question10,
                'question11': this.question11,
                'question12': this.question12,
                'question13': this.question13,
                'question14': this.question14
            };
        },
        getSubmittedForm (consultationId) {
            this.isLoading = true;

            this.axios.get('Consultation/GetConsultationCovid19Questionnaire', {
                'params': {
                    'consultationId': consultationId
                }
            }).then(({ data }) => {
                let questionnaireData = data.data;

                this.submissionFound = questionnaireData.hasQuestionnaire;

                if (this.submissionFound) {
                    this.submissionDate = convertToUserReadableDateTime(questionnaireData.createdAt);
                    this.question1 = questionnaireData.question1;
                    this.question2 = questionnaireData.question2;
                    this.question3 = questionnaireData.question3;
                    this.question4 = questionnaireData.question4;
                    this.question5 = questionnaireData.question5;
                    this.question6 = questionnaireData.question6;
                    this.question7a = questionnaireData.question7a;
                    this.question7b = questionnaireData.question7b;
                    this.question8 = questionnaireData.question8;
                    this.question9 = questionnaireData.question9;
                    this.question10 = questionnaireData.question10;
                    this.question11 = questionnaireData.question11;
                    this.question12 = questionnaireData.question12;
                    this.question13 = questionnaireData.question13;
                    this.question14 = questionnaireData.question14;
                }

                this.isLoading = false;
            });
        }
    }

};
</script>
